import { useMemo } from "react"
import { reduce, size } from "lodash"

export default function useActionPermissions(rows, editForm, deleteForm) {
  return useMemo(() => {
    const { editable: edit, deletable: del } = reduce(rows, (acc, { key, editable, deletable }) => {
      if (editable) {
        acc.editable.push(key)
      }
      if (deletable) {
        acc.deletable.push(key)
      }
      return acc
    }, { editable: [], deletable: [] })
    return [
      !editForm && !deleteForm, // noActions
      !size(edit), // noEdit
      !size(del), // noDelete
    ]
  }, [rows, editForm, deleteForm])
}
